import PropTypes from 'prop-types';
import React from 'react';
import { useLocation } from 'react-router-dom';
import urlHelper from '../../../utils/urlHelper';

function AssignmentSearch(props) {
  const location = useLocation();
  const { executeSearch, toggleFilters } = props;
  const [searchValue, setSearchValue] = React.useState(
    urlHelper.getUrlParam(location.search, 'search', ''),
  );

  return (
    <div className="h-[50px]">
      <div className="relative flex mt-4 bg-black">
        <div className="absolute w-full xl:w-full h-[50px] rounded-[15px]  bg-white flex items-center ">
          <button
            data-test="assignments-search-toggle-filters"
            type="button"
            className="absolute z-[40] left-[11px] cursor-pointer"
            onClick={toggleFilters}
          >
            <img src="/assets/images/icons/filter.svg" alt="" draggable={false} />
          </button>
          <input
            data-test="assignments-search-input"
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
            type="text"
            placeholder="Search content Assignments"
            className="pl-[44px] rounded-[15px] pr-[26%] xl:pr-[200px] w-full h-full outline-none poppins-regular font-[400] text-[14px] text-[#00243E] "
            onKeyDown={e => {
              if (e.key === 'Enter') {
                e.stopPropagation();
                executeSearch(searchValue);
              }
            }}
          />

          <img
            src="/assets/images/icons/search_input_icon.svg"
            alt="search icon"
            className="w-[22px] h-[22px] absolute right-[21%] xl:right-[169px]"
            draggable={false}
          />
        </div>

        <button
          data-test="assignments-search-button"
          type="button"
          onClick={() => executeSearch(searchValue)}
          className="absolute right-0 bg-[#FF5E00] text-[12px] md:w-[159px] w-[20%] hover:scale-105 h-[50px] duration-500 flex items-center justify-center rounded-[15px] poppins-bold font-700 text-white  xl:text-md 2xl:text-xl text-sm"
        >
          Search
        </button>
      </div>
    </div>
  );
}

AssignmentSearch.propTypes = {
  executeSearch: PropTypes.func.isRequired,
  toggleFilters: PropTypes.func.isRequired,
};

export default AssignmentSearch;
